import * as React from 'react';
import { InjectedFormProps, destroy, change } from 'redux-form';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;
import { InjectedRouter } from 'react-router';
import { IStore } from 'redux/IStore';
import {
	submitCreateOutfit,
	submitUpdateOutfit,
	clearOutfitFormData,
	nextStep,
	previousStep,
	addOutfitItem,
	removeOutfitItem,
} from 'modules/outfit/manageoutfit';
import { resetSearchData as resetWardrobeSearchData } from 'redux/modules/search/wardrobeitemsearchresults';
import { resetSearchData as resetProductSearchData } from 'redux/modules/search/productsearchresults';
import { IManageOutfit, IManageOutfitAction } from 'models/outfit/manageoutfit';
import { IOutfit } from 'models/outfit/outfit';
import * as c from 'models/constants';
import { StepSelectItems } from './StepSelectItems';
import { StepOutfit } from './StepOutfit';
import { ISelectorItem } from 'models/common';
import { IOutfitItem } from 'models/outfit/outfititem';
import { Modal } from 'components';
import { IModalAction } from 'models/modal';
import { SearchUsage } from 'models';

require('./style.css');

interface IProps extends InjectedFormProps {
	manageOutfit: IManageOutfit;
	router: InjectedRouter;
	route: any;
	userId: string;
	wardrobeItemsSearchUsage: SearchUsage;

	submitCreateOutfit: (outfit: IOutfit, onCreateOutfitSuccess: (outfit: IOutfit) => void) => IManageOutfitAction;
	submitUpdateOutfit: (outfit: IOutfit, onUpdateOutfitSuccess: (res: IOutfit) => void) => IManageOutfitAction;
	clearFormData?: () => IManageOutfitAction;
	destroy: (form: string) => IManageOutfitAction;
	nextStep: () => IManageOutfitAction;
	previousStep: () => IManageOutfitAction;
	addOutfitItem: (item: IOutfitItem) => IManageOutfitAction;
	removeOutfitItem: (index: number) => IManageOutfitAction;
	change: (field: string, data: any) => void;
	notifSend: (data: any) => void;
	t?: (key: string) => string;
	resetWardrobeSearchData?: () => void;
	resetProductSearchData?: () => void;
	closeModal?: () => IModalAction;
	onCreateOutfitSuccess?: (outfit: IOutfit) => void;
	onUpdateOutfitSuccess?: (outfit: IOutfit) => void;
}

@connect(
	(state: IStore) => {
		return {
			manageOutfit: state.manageOutfit,
		};
	},
	(dispatch) => ({
		submitCreateOutfit: (form: IOutfit, onCreateOutfitSuccess: (outfit: IOutfit) => void) =>
			dispatch(submitCreateOutfit(form, onCreateOutfitSuccess)),
		submitUpdateOutfit: (form: IOutfit, onUpdateOutfitSuccess: (res: IOutfit) => void) =>
			dispatch(submitUpdateOutfit(form, onUpdateOutfitSuccess)),
		clearFormData: () => dispatch(clearOutfitFormData()),
		destroy: (form: string) => dispatch(destroy(form)),
		nextStep: () => dispatch(nextStep()),
		previousStep: () => dispatch(previousStep()),
		addOutfitItem: (item: ISelectorItem) => dispatch(addOutfitItem(item)),
		removeOutfitItem: (index: number) => dispatch(removeOutfitItem(index)),
		change: (field: string, data: any) => dispatch(change(field, data)),
		notifSend: (data: any) => dispatch(notifSend(data)),
		resetWardrobeSearchData: () => dispatch(resetWardrobeSearchData()),
		resetProductSearchData: () => dispatch(resetProductSearchData()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageOutfit extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.addOutfitItem = this.addOutfitItem.bind(this);
		this.removeOutfitItem = this.removeOutfitItem.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetWardrobeSearchData();
		this.props.resetProductSearchData();
		this.props.clearFormData();
		this.props.destroy(c.FORM_NAME_MANAGEOUTFIT);
	}

	public onSubmit(form: IOutfit) {
		if (!this.props.manageOutfit.isEditMode) {
			this.props.submitCreateOutfit(form, this.props.onCreateOutfitSuccess);
		} else {
			this.props.submitUpdateOutfit(form, this.props.onUpdateOutfitSuccess);
		}
	}

	private addOutfitItem(item: ISelectorItem) {
		if (this.props.manageOutfit.outfit.itemsJArray.length < 5) {
			this.props.addOutfitItem(item);
		} else {
			this.props.notifSend({
				message: this.props.t('Outfit_CreateOutfit_NumberOfItems'),
				kind: 'warning',
				dismissAfter: 3000,
			});
		}
	}

	private removeOutfitItem(index: number) {
		this.props.removeOutfitItem(index);
	}

	public render() {
		const { wizardStep } = this.props.manageOutfit;
		const { route, router, previousStep, nextStep, wardrobeItemsSearchUsage } = this.props;

		const componentsProps = {
			route,
			router,
		};

		const selectItemsProps = {
			...componentsProps,
			nextStep,
			addOutfitItem: this.addOutfitItem,
			removeOutfitItem: this.removeOutfitItem,
			userId: this.props.userId,
			wardrobeItemsSearchUsage,
		};

		const outfitProps = {
			...componentsProps,
			previousStep,
			onSubmit: this.onSubmit,
		};

		return (
			<div className="wrapperModalCreateOutfit">
				<Modal showHeaderCloseButton={false} closeModal={this.props.closeModal}>
					<div className="manageOutfitContainerWrapper">
						{wizardStep === 1 && <StepSelectItems {...selectItemsProps} />}
						{wizardStep === 2 && <StepOutfit {...outfitProps} />}
					</div>
				</Modal>
			</div>
		);
	}
}

export { ManageOutfit };
